import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseCreditNoteTemplates = [
  {
    id: '-111001',
    language: Language.EN,
    subject: 'Credit Note',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Please find a detailed credit note for <strong>{{totalAmount}} €</strong> attached in relation with the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>Your current account balance is <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* This amount may not be up to date, if your payment has crossed the issue of this one.</p>
        {{/if}}`,
    status: true,
  },
  {
    id: '-111002',
    language: Language.FR,
    subject: 'Note de crédit',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Veuillez trouver ci joint, une note de crédit d'un montant de <strong>{{totalAmount}} €</strong> en lien avec le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>Votre solde actuel est de <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Ce montant pourrait ne pas être à jour, si votre paiement à croisé l'émission de la présente.</p>
        {{/if}}`,
    status: true,
  },
  {
    id: '-111003',
    language: Language.NL,
    subject: 'Creditnota',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Gelieve een gedetailleerde creditnota van <strong>{{totalAmount}} €</strong> bijgevoegd te vinden betreffende uw huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong>..</p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>Uw huidige rekeningsaldo is: <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Het kan zijn dat dit bedrag niet up-to-date is, als uw betaling de uitgifte van deze heeft overschreden.</p>
        {{/if}}`,
    status: true,
  },
  {
    id: '-111004',
    language: Language.DE,
    subject: 'Gutschrift',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Bitte finden Sie eine detaillierte Gutschrift über <strong>{{totalAmount}} €</strong> im Anhang bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>Ihr aktueller Kontostand beträgt <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Dieser Betrag ist möglicherweise nicht aktuell, falls sich Ihre Zahlung mit der Ausstellung überschnitten hat.</p>
        {{/if}}
        `,
    status: true,
  },
];
